import { FC, useEffect, useState } from 'react'
import CampaignApi from '../../../../infrastructure/api/CampaignApi'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Modal } from 'react-bootstrap-v5'
import { useFormik } from 'formik'
import { ICampaignModel, campaignInitValues } from '../../../../models/responses/CampaignModel'
import { ICampaignRequestModel } from '../../../../models/requests/CampaignRequestModel'
import { CampaignFormValidations } from '../../../validations/CampaignFormValidations'
import { FormikValidationError } from '../../../components/validations/FormikValidationError'
import { SaveChangesButton } from '../../../components/buttons/SaveChangesButton'
import { FileTypeEnum } from '../../../../enums/FileTypeEnum'
import { CampaignTypeEnum } from '../../../../enums/CampaignTypeEnum'
import { slugify } from '../../../helpers/StringHelper'
import FileApi from '../../../../infrastructure/api/FileApi'
import Select from 'react-select'
import { customSelectStyles } from '../../../helpers/ReactSelectHelper'
import { SelectModel } from '../../../models/SelectModel'
import { EnumToList } from '../../../helpers/EnumHelper'
import moment from 'moment'
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import { DefaultEditor } from '../../../components/editors/DefaultEditor'
import { EditorToolbarEnum } from '../../../enums/EditorToolbarEnum'

type Props = { itemId: number; show: boolean; handleClose: () => void }

const CampaignFormModal: FC<Props> = ({ itemId, show, handleClose }) => {
  const [loading, setLoading] = useState(false)
  const [complete, setComplete] = useState(false)

  const [loadLogoFile, setLoadLogoFile] = useState<any>(undefined)
  const [loadFile, setLoadFile] = useState<any>(undefined)
  const [logo, setLogo] = useState('')
  const [background, setBackground] = useState('')

  const [about, setAbout] = useState('')
  const [isVisible, setVisible] = useState<boolean>(false)

  const [campaign, setCampaign] = useState<ICampaignModel>(campaignInitValues)
  const updateCampaign = (fieldsToUpdate: Partial<ICampaignModel>) => {
    const updatedData = { ...campaign, ...fieldsToUpdate }
    setCampaign(updatedData)
  }

  const campaignTypeList = EnumToList(CampaignTypeEnum)
  const [selectedCampaignType, setSelectedCampaignType] = useState<SelectModel>(campaignTypeList[0])

  let now = new Date();
  let startTime = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
  let endTime = moment(startTime).add(1, "days").subtract(1, "seconds");

  const [start, setStart] = useState(startTime)
  const [end, setEnd] = useState(endTime)

  const applyCallback = (startDate: moment.Moment, endDate: moment.Moment) => {
    setStart(startDate)
    setEnd(endDate)
  }

  let ranges = {
    "Today Only": [moment(), moment()],
    "Yesterday Only": [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "3 Days": [moment().subtract(3, "days"), moment()]
  }

  let local = {
    "format": "YYYY/MM/DD",
    "sundayFirst": false
  }


  const formik = useFormik<ICampaignModel>({
    initialValues: campaign,
    enableReinitialize: true,
    validationSchema: CampaignFormValidations,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setTimeout(async () => {
        let model: ICampaignRequestModel = {
          id: values.id,
          name: values.name,
          about: about,
          head: values.head,
          link: values.link,
          isVisible: isVisible,
          startDate: start.format("YYYY-MM-DD"),
          endDate: end.format("YYYY-MM-DD"),
          logo: values.logo,
          image: values.image,
          campaignType: parseInt(selectedCampaignType.value),
        }
        processForm(model)
      }, 500)
    },
  })

  async function processForm(model: ICampaignRequestModel) {
    try {
      if (loadLogoFile !== undefined) {
        let d = new Date()
        const fileName = slugify(`${model.name}-${d.getMilliseconds()}-${d.getMinutes()}`)
        let modelPicture = new FormData()
        modelPicture.append('name', fileName)
        modelPicture.append('file', loadLogoFile)
        modelPicture.append('type', FileTypeEnum.Campaign)
        await FileApi.AddFile(modelPicture)
        model.logo = fileName + '.' + loadLogoFile.name.split('.').pop()
      }
      if (loadFile !== undefined) {
        let d = new Date()
        const fileName = slugify(`${model.name}-img-${d.getMilliseconds()}-${d.getMinutes()}`)
        let modelPicture = new FormData()
        modelPicture.append('name', fileName)
        modelPicture.append('file', loadFile)
        modelPicture.append('type', FileTypeEnum.CampaignBackground)
        await FileApi.AddFile(modelPicture)
        model.image = fileName + '.' + loadFile.name.split('.').pop()
      }
      var result = undefined
      if (model.id === undefined || model.id === 0) {
        result = await CampaignApi.AddCampaign(model)
      } else {
        result = await CampaignApi.UpdateCampaign(model)
      }
      formik.resetForm()
      handleClose()
    } catch (error) {
      alert('Error: ' + error)
      setLoading(false)
    }
    setLoading(false)
  }

  async function init() {
    let result: ICampaignModel
    if (itemId > 0) {
      var response = await CampaignApi.GetCampaign(itemId)
      result = response.data
      setStart(moment(result.startDate))
      setEnd(moment(result.endDate))
      setVisible(result.isVisible)
    } else {
      result = campaignInitValues
    }
    handleChangeCampaignType(result.campaignType ? campaignTypeList.find(i => i.value == result.campaignType.toString()) : campaignTypeList[0])

    setLogo(
      result.logo !== ''
        ? `${process.env.REACT_APP_CDN_URL}images/campaign/${result.logo}`
        : toAbsoluteUrl('/media/misc/none.png')
    )
    setBackground(
      result.image !== ''
        ? `${process.env.REACT_APP_CDN_URL}images/campaign/${result.image}`
        : toAbsoluteUrl('/media/misc/none.png')
    )
    setCampaign(result)
  }

  useEffect(() => {
    formik.resetForm()
    if (show) init()
  }, [itemId, show])

  const handleChangeLogo = (event: any) => {
    setLoadLogoFile(event.target.files[0])
    setLogo(URL.createObjectURL(event.target.files[0]))
  }

  const handleChangeBackground = (event: any) => {
    setLoadFile(event.target.files[0])
    setBackground(URL.createObjectURL(event.target.files[0]))
  }

  const handleChangeCampaignType = (e: any) => {
    setSelectedCampaignType(e)
  }

  const handleChangeVisible = () => {
    setVisible(!isVisible)
  }

  return (
    <Modal
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-800px h-auto'
      show={show}
      onHide={handleClose}
    >
      <form className='form w-100' onSubmit={formik.handleSubmit} noValidate>
        <div className='modal-content'>
          <div className='modal-header pb-0 border-0 justify-content-end'>
            <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
              <KTSVG path='/media/icons/duotone/Navigation/Close.svg' className='svg-icon-1' />
            </div>
          </div>
          <div className='modal-body mx-5 mx-xl-18 pt-0 pb-15'>
            <div className='text-center mb-13'>
              <h1 className='mb-3'>{itemId === 0 ? 'Add' : 'Edit'} Campaign</h1>
              <div className='text-muted fw-bold fs-5'>
                Campaign Management <small>Educall</small>
              </div>
            </div>
            <div className='row mb-10'>
              <div className='col-lg-6'>
                <label className='form-label fw-bolder'>Type</label>
                <Select
                  {...formik.getFieldProps('campaignType')}
                  styles={customSelectStyles(true)}
                  onChange={(event) => handleChangeCampaignType(event)}
                  value={selectedCampaignType}
                  options={campaignTypeList}
                />
                <FormikValidationError touched={formik.touched.campaignType} error={formik.errors.campaignType} />
              </div>
              <div className='col-lg-6'>
                <label className='form-label fw-bolder'>Date Range</label>
                <DateTimeRangeContainer
                  ranges={ranges}
                  start={start}
                  style={{
                    darkMode: true, standaloneLayout: { display: 'flex', maxWidth: 'fit-content' }
                  }}
                  end={end}
                  local={local}
                  applyCallback={applyCallback}
                >
                  <input
                    {...formik.getFieldProps('dateRange')}
                    id="formControlsTextB"
                    className='form-control form-control-solid'
                    value={`${start.format(local.format)} - ${end.format(local.format)}`}
                    type="text"
                  />
                </DateTimeRangeContainer>
              </div>
            </div>
            <div className='row mb-10'>
              <div className='col-lg-4'>
                <div className='mb-10'>
                  <label className='form-label fw-bolder'>Logo</label>
                  <div className='col-lg-8'>
                    <div
                      className='image-input image-input-outline'
                      data-kt-image-input='true'
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/misc/none.png')})`,
                        minWidth: '100%',
                      }}
                    >
                      <div
                        className='image-input-wrapper'
                        style={{
                          backgroundImage: `url(${logo})`,
                          minWidth: '100%',
                          backgroundSize: 'contain',
                          backgroundPosition: 'center',
                        }}
                      ></div>
                      <label
                        className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px form-control form-control-solid shadow'
                        data-kt-image-input-action='change'
                        data-bs-toggle='tooltip'
                        title=''
                        data-bs-original-title='Change logo'
                      >
                        <i className='fas fa-pencil-alt'></i>
                        <input
                          {...formik.getFieldProps('logo')}
                          type='file'
                          value={undefined}
                          onChange={(event) => handleChangeLogo(event)}
                          accept='.png, .jpg, .jpeg'
                        />
                      </label>
                      <span
                        className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                        data-kt-image-input-action='cancel'
                        data-bs-toggle='tooltip'
                        title=''
                        data-bs-original-title='Cancel logo'
                      >
                        <i className='bi bi-x fs-2'></i>
                      </span>
                    </div>
                    <FormikValidationError
                      touched={formik.touched.logo}
                      error={formik.errors.logo}
                    />
                  </div>
                </div>
                <div className=''>
                  <label className='form-label fw-bolder'>Background</label>
                  <div className='col-lg-8'>
                    <div
                      className='image-input image-input-outline'
                      data-kt-image-input='true'
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/misc/none.png')})`,
                        minWidth: '100%',
                      }}
                    >
                      <div
                        className='image-input-wrapper'
                        style={{
                          backgroundImage: `url(${background})`,
                          minWidth: '100%',
                          backgroundSize: 'contain',
                          backgroundPosition: 'center',
                        }}
                      ></div>
                      <label
                        className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px form-control form-control-solid shadow'
                        data-kt-image-input-action='change'
                        data-bs-toggle='tooltip'
                        title=''
                        data-bs-original-title='Change avatar'
                      >
                        <i className='fas fa-pencil-alt'></i>
                        <input
                          {...formik.getFieldProps('image')}
                          type='file'
                          value={undefined}
                          onChange={(event) => handleChangeBackground(event)}
                          accept='.png, .jpg, .jpeg'
                        />
                      </label>
                      <span
                        className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                        data-kt-image-input-action='cancel'
                        data-bs-toggle='tooltip'
                        title=''
                        data-bs-original-title='Cancel avatar'
                      >
                        <i className='bi bi-x fs-2'></i>
                      </span>
                    </div>
                    <FormikValidationError
                      touched={formik.touched.image}
                      error={formik.errors.image}
                    />
                  </div>
                </div>
              </div>
              <div className='col-lg-8'>
                <div className='mb-10'>
                  <label className='form-label fw-bolder required'>Name</label>
                  <input
                    {...formik.getFieldProps('name')}
                    type='text'
                    name='name'
                    className='form-control form-control-solid'
                    placeholder='Entry..'
                  />
                  <FormikValidationError
                    touched={formik.touched.name}
                    error={formik.errors.name}
                  />
                </div>
                <div className='mb-10'>
                  <label className='form-label fw-bolder required'>After About Head</label>
                  <input
                    {...formik.getFieldProps('head')}
                    type='text'
                    name='head'
                    className='form-control form-control-solid'
                    placeholder='Entry..'
                  />
                  <FormikValidationError touched={formik.touched.head} error={formik.errors.head} />
                </div>
                <div className='mb-10'>
                  <label className='form-label fw-bolder required'>Link</label>
                  <input
                    {...formik.getFieldProps('link')}
                    type='text'
                    name='link'
                    className='form-control form-control-solid'
                    placeholder='Entry..'
                  />
                  <FormikValidationError
                    touched={formik.touched.link}
                    error={formik.errors.link}
                  />
                </div>
                <div className=''>
                  <div className='form-check form-switch form-check-custom form-check-solid me-10'>
                    <input
                      {...formik.getFieldProps('isVisible')}
                      className='form-check-input h-30px w-50px'
                      type='checkbox'
                      name='isVisible'
                      checked={isVisible}
                      onClick={handleChangeVisible}
                    />
                    <label className='form-check-label'>Visible</label>
                  </div>

                </div>

              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <label className='form-label fw-bolder required'>About</label>
                <DefaultEditor
                  toolbars={[EditorToolbarEnum.Basic]}
                  setData={setAbout}
                  data={campaign.about}
                />
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <div className='d-flex flex-center '>
              <SaveChangesButton
                loading={loading}
                setLoading={setLoading}
                complete={complete}
                setComplete={setComplete}
                valid={formik.isValid}
                submit={formik.isSubmitting}
                setSubmit={formik.submitForm}
              />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  )
}

export { CampaignFormModal }
